import React, { useEffect } from 'react';
import { Hidden } from '@material-ui/core';
import Loader from '@cpg-its/ads.common.loading-circle';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import { getEmployeesList } from '../../../../global/ducks/benadmin-api';
import { getOrganization } from '../../../../global/ducks/organization-prc-api';
import { dispatchSetEmployeeList } from '../employment/employment-slice';
import { dispatchResetInstitutionClientNumber, dispatchSetCurrentInstitution, setDioceseList, setEmployeeListLoaded, setInstitutionClientNumber, setInstitutionGuid } from '../institutions/institution-slice';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { InstitutionItem, InstitutionState } from '../institutions/institution-model';
import { SearchProps } from '../../models/arc-epi-props';
import { SearchBar } from '../../../../search/components/search-bar';
import { ListPagination } from '../../../../search/components/list-pagination';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { TcsmStates } from '../../../../root/tcsm-model';
import { sortTableStyles } from '../../../../global/constants/theme/styles/tables/generic-sort-table';
import { getDioceseList, getOfficersList } from '../../../../global/ducks/wam-api';
import { dispatchSetOfficers } from '../institution-officers/institution-officers-slices';
import { usePersonManagementReset } from '../../hooks/usePersonManagementReset';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { DioceseListLabels } from './diocese-list-labels';
import { DioceseItemView } from './diocese-item-view';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { setNavigationContext } from '../../../../global/ducks/app-context';


export function DioceseSearch() {

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const initialList = useSelector<TcsmStates, InstitutionItem[]>(state => state.institutionState?.dioceseList);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps.searchSettingsState.epiContent);
	const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);
	const routeMatch = useRouteMatch();

	const { state } = useLocation<any>();

	const history = useHistory();
	const dispatch = useDispatch();
	const tableClasses = sortTableStyles();
	const gpsItem = useGpsType(GpsType.DIOCESE_LIST);
	usePersonManagementReset();


	const onSet = (institutionId, guid) => {
		dispatch(setInstitutionClientNumber(institutionId));
		dispatch(setInstitutionGuid(guid));
		dispatch(setNavigationContext(NavigationContext.Diocese));
		dispatch(getOrganization(institutionId, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));
		dispatch(getEmployeesList(institutionId, (response) => {
			dispatchSetEmployeeList(dispatch)(response);
			dispatch(setEmployeeListLoaded());
		}));
		dispatch(getOfficersList(institutionId, (response) => {
			dispatchSetOfficers(response, dispatch);
		}));

		
		if (state?.actionLink && state?.actionLink !== routeMatch) history.push(state.actionLink, state);					
	};

	useEffect(() => {
		dispatch(getDioceseList((data) => dispatch(setDioceseList(data?.data))));
	}, []);

	useEffect(() => {
		if (userNavigationContext === NavigationContext.Diocese){
			dispatch(setNavigationContext(NavigationContext.None));
		}		
	}, [userNavigationContext]);

	useEffect(() => {
		if (initialList?.length === 1) {
			const item = initialList[0];
			onSet((item as InstitutionItem).client_number, (item as InstitutionItem).guid);
		}
	}, [initialList?.length]);

	if (!institutionState.dioceseListLoaded) {
		return (<Loader />);
	}

	return (
		<>
			<PageHeader
				headerText={searchSettings?.dioceseSearchTitle}
			/>
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>
			</Hidden>
			<SearchApp initialList={initialList} appName='DioceseSearch'>
				{
					initialList?.length >= 10 && <SearchBar label={searchSettings.searchBarLabel} name='diocese-search-bar' filterProps={['client_number', 'diocese']} />

				}
				<div className={tableClasses.sortTable}>
					<Hidden xsDown>
						<DioceseListLabels settings={searchSettings} />
					</Hidden>
					<div className='sort-table-content'>
						<SearchList
							renderList={
								(item) => {
									return <DioceseItemView settings={searchSettings} key={item.id} item={item} action={() => { onSet((item as InstitutionItem).client_number, (item as InstitutionItem).guid); }} />;
								}
							}
							renderPagination={
								(totalCounts, name) => {
									return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings.nextButton} prevButton={searchSettings.previousButton} />;
								}
							}
							emptyMessage={searchSettings.emptyListMessage}
						/>
					</div>
				</div>
			</SearchApp>
		</>
	);
}

export default DioceseSearch;